module.exports = __webpack_public_path__ + "static/pr.f92ef798.png";